// Central helpers to work with backend media/paths.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const PLACEHOLDER = 'https://images.unsplash.com/photo-1563310978-dd47a28323ab';

export const getYoutubeId = (url) => {
  if (!url) return null;
  const str = String(url).trim();
  if (/^[\w-]{11}$/.test(str)) return str;
  const match = str.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/|live\/|watch\?.+&v=))([\w-]{11})/i);
  return match ? match[1] : null;
};

export const staticImg = (name, fallback = PLACEHOLDER) => {
  if (!name) return fallback;
  const s = String(name).trim();
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')) return s;
  if (s.startsWith('/uploads/')) return s;
  if (s.startsWith('uploads/')) return `/${s}`;
  if (s.startsWith('/assets/')) return s;
  if (s.startsWith('assets/')) return `/${s}`;
  if (s.startsWith('/')) return s;
  if (
    s.startsWith('prod_') ||
    s.startsWith('freeprod_') ||
    s.startsWith('cat-') ||
    s.startsWith('cat_') ||
    s.startsWith('site_logo') ||
    s.startsWith('site_favicon') ||
    s.startsWith('bank_')
  ) {
    return `/assets/img/${s}`;
  }
  if (s.startsWith('upload_')) return `/uploads/${s}`;
  return `/uploads/${s}`;
};

export const uploadImg = (name, fallback = PLACEHOLDER) => {
  if (!name) return fallback;
  if (String(name).startsWith('http')) return name;
  if (String(name).startsWith('/uploads')) return `${BACKEND_URL}${name}`;
  return `${BACKEND_URL}/uploads/${name}`;
};

export const fmtPrice = (n) => Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 0 });
export const fmtMoney = (n) => Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 });

export const stripHtml = (htmlStr) => {
  if (!htmlStr) return '';
  const str = String(htmlStr)
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim();
  return str;
};

export const parseServerFeatures = (feats) => {
  if (!feats) return {};
  if (typeof feats === 'object') return feats;
  try { return JSON.parse(feats); } catch { return {}; }
};

export const featureList = (feats) => Object.values(parseServerFeatures(feats));
